import Route from '@ember/routing/route';
import { service } from '@ember/service';
import FundMappingsService from 'donor-elf-web/services/fund-mappings-service';

export default class FundMappingsRoute extends Route {
  @service declare fundMappingsService: FundMappingsService;
  @service declare fundsService: any;
  @service declare navbarSettings: any;

  beforeModel() {
    this.navbarSettings.title = 'Fund Mappings';
    return this.fundsService.confirmValidFundToken();
  }

  async model() {
    return {
      fundMappings: this.fundMappingsService.fundMappings,
    };
  }
}
